export const ROLES = {
  BUTTON: 'button',
};

export const TAB_INDICES = {
  NEGATIVE: -1,
  ZERO: 0,
  POSITIVE: 1,
};
